module.exports = __webpack_public_path__ + "static/5-2-4c37f1b77a19908f0c85ec2dbb4a5664.png";